import React from 'react';

const WiredInput = ({
  fieldState,
  formState,
  updateFormState,
  handleValueChange,
  showValidationMessage,
  handleBlur,
  showMessage,
  label,
  ...restProps
}) => {
  if (restProps.type === 'radio') {
    restProps.checked = `${fieldState.getValue()}` === `${restProps.value}`;
    restProps.readOnly = true;
  } else if (restProps.type === 'checkbox') {
    restProps.checked = !!+fieldState.getValue();
    restProps.readOnly = true;
  }

  return (
    <input value={fieldState.getValue()} onBlur={handleBlur} {...restProps} />
  );
};

export default WiredInput;



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/WiredInput.js